import axios, { AxiosInstance } from 'axios';
import cachios from 'cachios';
import { print, DocumentNode } from 'graphql';
import { captureException } from '@sentry/vue';

declare const GRAPHQL_ENDPOINT: string;
declare const GRAPHQL_TOKEN: string;

// Configure the GraphQL api endpoint
export const createApi = () => {
  const axiosInstance = axios.create({
    baseURL: GRAPHQL_ENDPOINT,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      ...(GRAPHQL_TOKEN && { Authorization: `Bearer ${GRAPHQL_TOKEN}` }),
    },
  });

  return cachios.create(axiosInstance, {});
};

// Execute a GraphQL query by sending an XHR to our api endpoint
export const executeGqlQuery = async (
  api: AxiosInstance,
  query: DocumentNode,
  variables: any,
  callback: CallableFunction,
  reject?: CallableFunction
): Promise<any> => {
  // Execute the GQL query
  try {
    const response = await api.post('', {
      query: print(query),
      variables,
    });

    if (callback && response.data.data) {
      return callback(response.data.data);
    }
  } catch (error) {
    captureException(error);
    if (reject) {
      reject(error);
    }
  }
  return null;
};
